import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BackendHealthService } from './core/backend-health/backend-health.service';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private readonly backendHealth = inject(BackendHealthService);

  ngOnInit(): void {
    // Ping al backend al arrancar para detectar VM/container down ANTES de
    // que el usuario intente loguearse. Si falla, BackendHealthService
    // dispara el snackbar global y loguea explicito a consola.
    this.backendHealth.checkOnce().subscribe();
  }
}
